import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Event from './pages/Event';
import Checkout from './pages/Checkout';
import Success from './pages/Success';
import Admin from './pages/Admin';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Register from './pages/Register';
import MyTickets from './pages/MyTickets';
import ProtectedRoute from './components/ProtectedRoute';
import Profile from './pages/Profile';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import PaymentSuccess from './pages/PaymentSuccess';
import CookieBanner from './components/CookieBanner';
import TicketValidator from './pages/TicketValidator';
import Scanner from './pages/Scanner';
import Promotor from './pages/Promotor';
import AutorizacionMenores from './pages/AutorizacionMenores';
import Footer from './components/Footer';
import SeriesPage from './pages/SeriesPage';
import VendeTusEntradas from './pages/VendeTusEntradas';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <CookieBanner />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/autorizacion-menores" element={<AutorizacionMenores />} />
          <Route path="/checkout/:id" element={<Checkout />} />
          <Route path="/success" element={<Success />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/register" element={<Register />} />
          <Route path="/v/:code" element={<TicketValidator />} />
          <Route path="/escanear" element={<Scanner />} />
          <Route path="/promotor" element={<Promotor />} />
          <Route path="/admin" element={
            <ProtectedRoute adminOnly={true}>
              <Admin />
            </ProtectedRoute>
          } />
          <Route path="/my-tickets" element={
            <ProtectedRoute>
              <MyTickets />
            </ProtectedRoute>
          } />
          <Route path="/profile" element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          } />
          <Route path="/coleccion/:slug" element={<SeriesPage />} />
          <Route path="/vende-tus-entradas" element={<VendeTusEntradas />} />
          <Route path="/:id" element={<Event />} />
        </Routes>
        <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App;